import { defineMessages } from 'react-intl';

export default defineMessages({
  addToOrder: {
    id: 'ordering.productDetails.addToOrderButton',
    defaultMessage: 'Add to Order {totalAmount}',
    description: 'The add to cart button in a product details page',
  },
  backToOrder: {
    id: 'ordering.productDetails.backToOrder',
    defaultMessage: 'Back to order',
    description: 'Frap for returning to cart from PDP',
  },
  updateItem: {
    id: 'ordering.productDetails.updateItem',
    defaultMessage: 'Update item {totalAmount}',
    description: 'Frap for when editing a cart item is complete',
  },
  backToPreviousOrFavorites: {
    id: 'ordering.productDetails.backToPreviousOrFavorites',
    defaultMessage:
      'Back to {isComingFromPrevious, select, true {previous} other {favorites}}',
    description:
      'Frap for going back to previous or favorites, depending on where user came from',
  },
  totalPriceUpdated: {
    id: 'ordering.productDetails.totalPriceUpdated',
    defaultMessage: '{productName} total updated. {totalAmount}',
    description:
      'Label for vo announcing the updated total price for after adding new customizations',
  },
});
